import React from "react";
import { driveThumb } from "../data/categoriesData";

const STUDIO_IMAGE_ID = "1FBF5telXnG6pp8JUo5KMCCEkSu4ZtWnD";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-black border-t border-white/5 py-16 sm:py-24 lg:py-28"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          {/* Left: image + meta */}
          <div className="md:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={driveThumb(STUDIO_IMAGE_ID, 1400)}
                alt="Inside the studio, Momenta crew at work."
                className="w-full h-full object-cover img-noise"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/15" />
              <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between gap-3">
                <div className="font-serif italic text-white text-lg sm:text-xl leading-tight">
                  "Every second, <br />a story."
                </div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/60 font-mono whitespace-nowrap">
                  Manifesto
                </div>
              </div>
            </div>

            <div className="mt-6 flex items-center gap-4">
              <div className="eyebrow">The Studio</div>
              <div className="h-[1px] bg-white/15 flex-1" />
              <div className="eyebrow font-mono">Mumbai</div>
            </div>
          </div>

          {/* Right: copy + stats */}
          <div className="md:col-span-7">
            <h2 className="font-serif text-white text-3xl sm:text-5xl lg:text-6xl font-light tracking-tighter leading-[1.05]">
              We craft <em className="italic font-medium">bold, cinematic</em>{" "}
              content for brands that refuse to blend in.
            </h2>

            <div className="mt-8 sm:mt-10 space-y-5 text-white/70 text-base sm:text-lg font-light leading-relaxed max-w-2xl">
              <p>
                Product launches, brand films, social campaigns. We turn brand
                values into visuals that make people stop, feel and remember.
              </p>
              <p>
                From startups to established brands, we partner with those who
                believe every moment matters.
              </p>
              <p className="font-serif italic text-white/90 text-xl sm:text-2xl pt-4">
                Every second, a story.
              </p>
            </div>

            <div className="mt-12 sm:mt-16 grid grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
              <div data-testid="stat-years">
                <div className="font-serif text-white text-4xl sm:text-5xl font-light">
                  07
                </div>
                <div className="eyebrow mt-2">Years · Active</div>
              </div>
              <div data-testid="stat-projects">
                <div className="font-serif text-white text-4xl sm:text-5xl font-light">
                  240+
                </div>
                <div className="eyebrow mt-2">Projects · Shipped</div>
              </div>
              <div data-testid="stat-clients">
                <div className="font-serif text-white text-4xl sm:text-5xl font-light">
                  40+
                </div>
                <div className="eyebrow mt-2">Brands · Served</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
